<template>
  <div class="size-guide">
    <div class="size-guide__trigger">
      <RulerIcon :color="`var(--v4_color_primary)`" />
      <a @click.prevent="openSizeGuideModal">
        {{ $t('guide_sizes.title') }}
      </a>
    </div>
    <modal
      data-modal="size-guide"
      :open="isModalOpen"
      :content-class="'size-guide__modal'"
      :max-width="'600'"
      :fixed-btn="false"
      :show-footer="false"
      @close="closeModal"
    >
      <template v-slot:title>
        <b>{{ $t('guide_sizes.title') }}</b>
      </template>
      <div v-if="isModalOpen">
        <div class="size-guide__section">
          <p class="size-guide__section-title">
            {{ $t('guide_sizes.compatibility_text') }}
          </p>
        </div>
        <div class="size-guide__section">
          <ul class="size-guide__tabs">
            <li
              v-for="(device, index) in devices"
              :key="device.id"
              :class="{
                'size-guide__tab--active': index === selectedTab,
              }"
              class="size-guide__tab"
              @click="selectedTab = index"
            >
              {{ device.name }}
            </li>
          </ul>
        </div>
        <div class="size-guide__section">
          <div v-if="selectedDeviceContent">
            <span class="size-guide__text">
              {{ selectedDeviceContent.measure_title }}
            </span>
            <span class="size-guide__size">
              {{ selectedDeviceContent.case_dimensions }}
            </span>
            <span class="size-guide__text">
              {{ $t('guide_sizes.fits_notebooks_with') }}
            </span>
            <span class="size-guide__size">
              {{ selectedDeviceContent.device_dimensions }}
            </span>
            <p class="size-guide__observation">
              {{ $t('guide_sizes.note') }}
            </p>
          </div>
        </div>
        <div class="size-guide__section">
          <p class="size-guide__section-title">
            {{ $t('guide_sizes.check_example') }}
          </p>
          <div v-if="selectedDeviceContent">
            <img
              :src="selectedDeviceContent.image_src"
              :alt="selectedDeviceContent.image_alt"
            />
          </div>
        </div>
        <div class="size-guide__section">
          <p class="size-guide__help">
            {{ $t('guide_sizes.need_help') }}
            <a href="http://goca.se/whatsapp" target="_blank">{{
              $t('guide_sizes.click_here')
            }}</a>
            {{ $t('guide_sizes.contact_team') }}
          </p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import RulerIcon from '@/components/icons/guide-sizes/RulerIcon.vue'
import Modal from '~/components/Modal.vue'
export default {
  name: 'GuideSizesModal',
  components: {
    RulerIcon,
    Modal,
  },
  props: {
    devices: {
      type: Array,
      required: true,
    },
    initialSelectedDeviceIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedTab: this.initialSelectedDeviceIndex,
      isModalOpen: false,
    }
  },
  computed: {
    deviceContentItems() {
      return [
        {
          code: 'capanotebook14',
          measure_title: this.$t('guide_sizes.measure_title_14'),
          case_dimensions: this.$t('guide_sizes.case_dimensions_14'),
          device_dimensions: this.$t('guide_sizes.device_dimensions_14'),
          image_src:
            'https://ik.imagekit.io/gocase/engines/qr-img/227544948819624621727793253556.png',
          image_alt: this.$t('guide_sizes.image_alt_14'),
        },
        {
          code: 'capanotebook15',
          measure_title: this.$t('guide_sizes.measure_title_15'),
          case_dimensions: this.$t('guide_sizes.case_dimensions_15'),
          device_dimensions: this.$t('guide_sizes.device_dimensions_15'),
          image_src:
            'https://ik.imagekit.io/gocase/engines/qr-img/132222245772080971727793306644.png',
          image_alt: this.$t('guide_sizes.image_alt_15'),
        },
      ]
    },
    selectedDeviceContent() {
      return this.deviceContentItems.find(
        (item) => item.code === this.selectedDevice.code
      )
    },
    selectedDevice() {
      return this.devices[this.selectedTab]
    },
  },
  watch: {
    initialSelectedDeviceIndex(newIndex) {
      this.selectedTab = newIndex
    },
    isModalOpen(newVal) {
      if (newVal) {
        this.selectedTab = this.initialSelectedDeviceIndex
      }
    },
  },
  methods: {
    openSizeGuideModal() {
      this.isModalOpen = true
    },
    closeModal() {
      this.isModalOpen = false
    },
  },
}
</script>

<style lang="scss">
$text-gray: #8f8f8f;
$border-gray: #ccc;
:root {
  --v4_color_primary: #{$v4_color_primary};
}
.modal-velociraptor__body {
  padding-bottom: 0 !important;
}
.size-guide {
  p {
    text-align: justify;
  }
  a {
    font-weight: bold;
    color: $v4_color_primary;
  }
  img {
    border-radius: 5px;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    margin-top: auto;
    width: 100%;
    max-width: 100%;
  }
  &__trigger {
    display: flex;
    align-items: center;
    padding-top: 10px;
    margin-top: 10px;
    text-align: center;
    a {
      font-size: 13px;
      margin-left: 5px;
      transition: color 0.3s ease;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  &__section {
    &:not(:first-of-type) {
      margin-top: 40px;
    }
  }
  &__tabs {
    display: flex;
    justify-content: center;
    list-style: none;
    padding: 0;
    border-bottom: 1px solid $border-gray;
    .size-guide__tab {
      width: 50%;
      text-align: center;
      padding: 10px 0;
      cursor: pointer;
      font-weight: 600;
      color: $text-gray;
      border-bottom: 2px solid transparent;
      transition: color 0.3s ease;
      &:hover {
        color: var(--v4_color_primary);
      }
      &--active {
        color: var(--v4_color_primary);
        border-bottom-color: var(--v4_color_primary);
      }
    }
  }
  &__text {
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
  }
  &__size {
    font-size: 15px;
    display: block;
    margin-bottom: 20px;
    font-weight: bold;
    color: $v4_color_primary;
    &:last-of-type {
      margin-bottom: 10px;
    }
  }
  &__observation {
    font-size: 12px;
    font-weight: 600;
    font-style: italic;
  }
  &__help {
    font-size: 12px;
    a {
      text-decoration: underline;
      font-size: 12px;
    }
  }
  @media (min-width: $screen_tablet) {
    &__trigger {
      a {
        font-size: 16px;
      }
    }
    &__section-title {
      font-size: 15px;
    }
    &__text {
      font-size: 15px;
    }
    &__size {
      font-size: 17px;
    }
    &__observation {
      font-size: 12px;
    }
    &__help {
      font-size: 14px;
      a {
        font-size: 14px;
      }
    }
  }
}
</style>
